/* eslint-disable import/no-cycle */
/* eslint-disable import/first */
import React, { useState, useCallback, useRef, useEffect } from 'react';
import { Button } from '@material-ui/core';
import { GoogleMap, useLoadScript, Marker, InfoWindow } from '@react-google-maps/api';
import { FormattedMessage, useIntl } from 'react-intl';
import { Loader as GeoLoader } from '@googlemaps/js-api-loader';
import { FiSearch } from '@react-icons/all-files/fi/FiSearch';
import { FiArrowRight } from '@react-icons/all-files/fi/FiArrowRight';
import { useNavigate, useLocation } from '@reach/router';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import usePlacesAutocomplete, { getGeocode, getLatLng } from 'use-places-autocomplete';
import {
  Combobox,
  ComboboxInput,
  ComboboxPopover,
  ComboboxList,
  ComboboxOption,
} from '@reach/combobox';
const { selectCountryValidations, selectBaseURL, selectOrderModesByCountry } = Slices.configSlice;
const { selectDesktop, getCountryPopState } = Slices.appSlice;
import { Location } from '../../components/Icons';
import { GoLocation } from '@react-icons/all-files/go/GoLocation';
import { GrClose } from '@react-icons/all-files/gr/GrClose';
import { MdMyLocation } from '@react-icons/all-files/md/MdMyLocation';
import { IoMdClose } from '@react-icons/all-files/io/IoMdClose';
import { RiCloseLine } from '@react-icons/all-files/ri/RiCloseLine';
import Header from '../../components/Header';
import OrderModesBar from '../../components/OrderModesBar';
import LanguageButton from '../../components/LanguageButton';

import mapStyles from './mapStyles';
const {
  editAddress,
  validateLocation,
  setCloseEditAddressPopup,
  selectDefaultAddress,
  selectAddress,
} = Slices.addressSlice;

import DrawerPwa from '../../components/DrawerPwa';
import ChangeAddress from '../AddAddress/ChangeAddress';
import { getFormatedResult, getcurrentCountry, geoCodeShortName } from 'spwa-ui-library/esm/utils/helper';
import CountrySelection, { countryList } from '../../components/CountryDropdown';
import css from './index.module.scss';

import ClassNames from 'classnames';
// constants added to support map functionality
const libraries = ['places'];
const mapContainerStyle = {
  height: '100%',
  width: '100%',
};

function EditAddress({ addressId, closePopUp }) {
  //Map key added  - used personal
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const profile = useSelector((state) => state.profile);
  const imgBaseUrl = useSelector(selectBaseURL);
  const defaultAddress = useSelector(selectDefaultAddress);

  const countryValidations = useSelector((state) =>
    selectCountryValidations(state, profile.country)
  );
  const isDesktop = useSelector(selectDesktop);
  // const { oldLocation = JSON.parse(JSON.stringify(location)) } = location.state || [];
  const address = useSelector((state) => state.address);
  const [addInfo, setAddInfo] = useState(address?.isEditAdressPopupOpen);
  const isExist = address.data.info.findIndex(({ id }) => id === addressId);
  const addLat = address.data.info[isExist]?.lat;
  const addLng = address.data.info[isExist]?.lng;
  const addAdr = address.data.info[isExist]?.description;

  const [center, setCenter] = React.useState({
    lat: addLat,
    lng: addLng,
  });

  const orderModes = useSelector((state) => selectOrderModesByCountry(state, profile.country));
  const [validateError, setValidateError] = useState('');
  const Icon = orderModes.find((val) => val.type === 'DELIVERY')?.imageAlt;

  const options = {
    styles: mapStyles,
    disableDefaultUI: true,
    zoomControl: false,
  };

  const getCountryNameFromCode = (code) => {
    let countryName = code;
    for (let i = 0; i < countryList.length; i++) {
      if (countryList[i].code === code) {
        countryName = countryList[i].name;
        break;
      }
    }
    return countryName;
  };

  const searchLocation = intl.formatMessage({ id: 'addaddress_searchlocation' });
  const allTags = [
    { id: 'HOME', val: intl.formatMessage({ id: 'home_tag' }) },
    { id: 'OFFICE', val: intl.formatMessage({ id: 'office_tag' }) },
    { id: 'HOTEL', val: intl.formatMessage({ id: 'hotel_tag' }) },
    { id: 'OTHER', val: intl.formatMessage({ id: 'trackorder_others' }) },
  ];

  const mapkey = process?.env?.REACT_APP_MAPS_API_KEY || '';

  //Geocoder Configurations
  const geoCoderLoadScript = async () => {
    const loader = new GeoLoader({
      apiKey: process?.env?.REACT_APP_MAPS_API_KEY || '',
      version: 'weekly',
      language: intl.locale,
      region: 'ae',
    });
    await loader.load();
  };

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: mapkey,
    libraries,
  });

  let poly = null;
  const [servicedCountryPolygons, setServicedCountryPolygons] = useState({});

  const contrySpecificValidation = useSelector(
    (state) => state.config?.data?.data?.contrySpecificValidation
  );

  useEffect(() => {
    let polygons = {};
    // polygons[result.data.country] = result.data.data;
    // eslint-disable-next-line no-unused-expressions
    contrySpecificValidation?.forEach((country) => {
      polygons[country?.country] = country?.countryGeoFenceCoords?.map((data) => ({
        lat: data[0],
        lng: data[1],
      }));
    });
    setServicedCountryPolygons(polygons);
  }, []);

  const checkLocationInsidePolygon = async (location, polygonData) => {
    if (!isLoaded) return false;
    if (!poly) ({ poly } = await window.google.maps.importLibrary('geometry'));
    const polygon = new window.google.maps.Polygon({ paths: polygonData });
    return poly.containsLocation(location, polygon);
  };

  const updateLocation = async (lat, lng) => {

    const currentLocation = new window.google.maps.LatLng(lat, lng);
    const countries = countryList.reduce((result, country) => {
      result = result.concat(country.code);
      return result;
    }, []);

    let isInsideServicedCountry = false;
    for await (let country of countries) {
      if (await checkLocationInsidePolygon(currentLocation, servicedCountryPolygons[country])) {
        isInsideServicedCountry = true;
        break;
      }
    }

    if (isInsideServicedCountry) {
      // check if location is in current profile country or not
      try {
        await geoCoderLoadScript();
        const geocoder = new window.google.maps.Geocoder();
        const { results } = await geocoder.geocode({ location: { lat, lng } });

        if (results && results[0]) {
          let formatedAddr = getFormatedResult(results);
          let countryCode = geoCodeShortName[getcurrentCountry(results)];

          if (countryCode == profile.country) {
            setMarkers([
              {
                lat: lat,
                lng: lng,
                address: formatedAddr,
              },
            ]);
          }
        }
      } catch (error) {}
    }
  };

  useEffect(() => {
    setBldNu(address.data.info[isExist]?.bldgName);
    setFlatNu(address.data.info[isExist]?.flatNum);

    setCenter({
      lat: address.data.info[isExist]?.lat,
      lng: address.data.info[isExist]?.lng,
    });
  }, [address.data.info, isExist]);


  const successPosition = async (position) => {
    const lat = position.coords.latitude;
    const lng = position.coords.longitude;

    await updateLocation(lat, lng);

    setCenter({
      lat: lat,
      lng: lng,
    });
  };
  const deniedPosition = (error) => {
    alert(intl.formatMessage({ id: 'location_denied' }));
  };
  const [stateOpen, setStateOpen] = React.useState(false);
  const [errorResponse, setErrorResponse] = React.useState('');
  const [markers, setMarkers] = useState([]);
  const [bldNu, setBldNu] = useState();
  const [flatNu, setFlatNu] = useState();
  const countryPopup = useSelector(getCountryPopState);
  const [howTo, setHowTo] = useState(address.data.info[isExist]?.howToReach);
  const [tag, setTag] = useState(address.data.info[isExist]?.tag || 'home');
  const [status, setStatus] = useState('initial');
  const searchInput = useRef();
  const [selected, setSelected] = useState(null);
  const handleClickAway = () => {
    setStateOpen(false);
  };

  const howToReachpl = intl.formatMessage({ id: 'how_to_reach' });
  useEffect(() => {
    if (isExist === -1 && !address?.data?.info?.length && address?.status === 'idle') {
      isDesktop
        ? navigate(`${location.pathname}?modal=addaddress`, { replace: true })
        : navigate(`/${intl.locale}/addAddress`, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isExist, address.status]);
  const onMapClick = useCallback(async (e) => {
    const newLat = e.latLng.lat();
    const newLang = e.latLng.lng();

    await updateLocation(newLat, newLang);
  }, []);

  const handleForm = () => {
    closePopUp && closePopUp();
    setStatus('loading');
    const addressPayload = {
      addressId: addressId,
      bldgName: bldNu,
      description: markers[0].address,
      flatNum: flatNu,
      howToReach: howTo,
      lat: markers[0].lat,
      lng: markers[0].lng,
      tag: tag.toString().toUpperCase(),
    };
    dispatch(editAddress(addressPayload)).then((addRespons) => {
      if (addRespons.meta.requestStatus !== 'rejected') {
        if (addRespons?.payload?.data?.data?.id === defaultAddress?.id) {
          dispatch(selectAddress(addRespons?.payload?.data?.data));
        }
        navigate(-1);
      } else {
        setStateOpen((prev) => false);
        setStateOpen((prev) => true);
        localStorage.setItem('editAddressError', addRespons.error.message);
        setErrorResponse(addRespons.error.message);
      }
    });
  };
  useEffect(() => {
    setMarkers([
      {
        lat: addLat,
        lng: addLng,
        address: addAdr,
      },
    ]);
  }, [addAdr, addLat, addLng, status]);
  useEffect(() => {
    if (markers[0] && bldNu && flatNu) {
      setStatus('fullfilled');
    }
  }, [markers, bldNu, flatNu, howTo, addLat, addLng]);

  useEffect(() => {
    if (markers.length && markers[0]?.lat) {
      const payload = {
        lat: markers[0].lat,
        lng: markers[0].lng,
        screen: 'LOCATION',
        addressSubType: 'DELIVERY',
      };
      dispatch(validateLocation(payload)).then((resp) => {
        if (resp.error) {
          setValidateError(resp.error.message);
        } else {
          if (resp.payload.data.data.store.services.del === 0) {
            setValidateError('Sorry Store Doesnt Deliver Here Yet');
          } else {
            setValidateError('');
          }
        }
      });
    }
  }, [dispatch, markers]);
  const mapRef = useRef();
  const onMapLoad = useCallback((map) => {
    mapRef.current = map;
  }, []);
  const panTo = useCallback(({ lat, lng }) => {
    mapRef.current.panTo({ lat, lng });
    mapRef.current.setZoom(18);
  }, []);
  const getCurrentLoc = () => {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (pos) => successPosition(pos),
        (err) => deniedPosition(err)
      );
    } else {
      alert("Your Browser doesn't support location service !");
    }
  };

  const Search = ({ refrence, panTo }) => {
    const {
      ready,
      value,
      suggestions: { status, data },
      setValue,
      clearSuggestions,
    } = usePlacesAutocomplete({
      requestOptions: {
        location: { lat: () => 25.204849, lng: () => 55.270782 },
        radius: 100 * 1000,
        componentRestrictions: {
          country:
            profile.country === 'UAE' ? 'ae' : countryValidations?.shortCountryName?.toLowerCase(),
        },
      },
    });
    const [selectedHover, setSelectedHover] = useState([{}]);
    const handelHover = (id) => {
      setSelectedHover([{ [id]: !selectedHover[id] }]);
    };
    const handleInput = (e) => {
      setValue(e.target.value);
    };
    // eslint:fix map is replaced with forEach
    const getAddressValue = (terms) => {
      let value = [];
      terms.length &&
        terms.forEach((el) => {
          value.push(el.value);
        });
      return value.join(',');
    };
    const handleSelect = async (address) => {
      setValue(address, false);
      clearSuggestions();

      try {
        const results = await getGeocode({ address });
        const { lat, lng } = await getLatLng(results[0]);
        panTo({ lat, lng });
        setMarkers([
          {
            lat: lat,
            lng: lng,
            address: results[0].formatted_address,
          },
        ]);
      } catch (error) {
        // TODO: Handle error scenario gracefully
        // console.log('Error: ', error);
      }
    };

    return (
      <div className={css.search}>
        <Combobox onSelect={handleSelect}>
          <FiSearch size="20px" className={css.icon} />
          <ComboboxInput
            id="focusme"
            value={value}
            onChange={handleInput}
            disabled={!ready}
            ref={refrence}
            autoFocus
            placeholder={searchLocation}
          />
          <div className={css.countryDrop}>
            <CountrySelection showName={false} />
          </div>
          {value && (
            <RiCloseLine size="2rem" className={css.closeIcon} onClick={() => setValue('')} />
          )}

          <ComboboxPopover portal={false} className={css.comboPop}>
            {data.length > 0 ? (
              <ComboboxList className={css.searchSugg}>
                {status === 'OK' &&
                  data.map(({ place_id, terms }) => {
                    const addressDetail = getAddressValue(terms);
                    return (
                      <ComboboxOption
                        key={`map-combo-${Math.random()}-${terms[0].value}`}
                        value={addressDetail}
                        className={css.optionBox}
                      >
                        <div
                          className={css.optionItem}
                          onMouseEnter={() => handelHover(place_id)}
                          onMouseLeave={() => handelHover(!place_id)}
                        >
                          <div className={css.iicon}>
                            <GoLocation size="18px" />
                          </div>
                          <div className={css.locTitle}>
                            {terms[0].value}
                            <span>
                              {terms[1]?.value} - {terms[2]?.value}
                            </span>
                          </div>
                          {Object.keys(selectedHover[0])[0] === place_id && (
                            <div className={css.iconRight}>
                              <FiArrowRight size={'20px'} />
                            </div>
                          )}
                        </div>
                      </ComboboxOption>
                    );
                  })}
              </ComboboxList>
            ) : (
              <span style={{ margin: 8 }}>No results found</span>
            )}
          </ComboboxPopover>
        </Combobox>
      </div>
    );
  };
  const buildingPlaceholder = intl.formatMessage({ id: 'building_name' });
  const flatNoPlaceholder = intl.formatMessage({ id: 'flat_no' });
  const changeMap = () => {
    // SET TO false IF EDIT POPUP OPEN
    if (address?.isEditAdressPopupOpen) {
      dispatch(setCloseEditAddressPopup(false));
    }
    setAddInfo(!addInfo);

    searchInput.current.focus();
  };
  // useEffect(() => {
  //   if (!isLoaded && isExist === -1) {
  //     isDesktop
  //       ? navigate(`${location.pathname}?modal=addaddress`, { replace: true })
  //       : navigate(`/${intl.locale}/addAddress`, { replace: true });
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  if (loadError) return 'Error';
  if (!isLoaded) return '';
  return (
    <div className={css.root}>
      {!isDesktop && (
        <Header
          title={<FormattedMessage id="editaddress_editaddress" defaultMessage="Select Address" />}
          secondaryBar={<OrderModesBar defaultModeIdx={0} />}
          actionButtons={[<LanguageButton />]}
        />
      )}
      {isDesktop && (
        <div className={css.desktopHeader}>
          <div className={css.icon}>
            <img src={`${imgBaseUrl.home}${Icon}`} alt="" />
          </div>
          <div className={css.heading}> Select Delivery Location</div>
          <div className={css.Closebutton}>
            <Button onClick={closePopUp}>
              <IoMdClose />
            </Button>
          </div>
        </div>
      )}
      <main className={css.main}>
        <div className={css.section}>
          <div className={css.addAddress}>
            <div className={css.Map}>
              <Search refrence={searchInput} panTo={panTo} />
              <GoogleMap
                id="map"
                mapContainerStyle={mapContainerStyle}
                zoom={14}
                options={options}
                onClick={onMapClick}
                center={center}
                onLoad={onMapLoad}
              >
                {markers.map((marker) => (
                  <Marker
                    key={`${marker.lat}-${marker.lng}`}
                    position={{ lat: marker.lat, lng: marker.lng }}
                  />
                ))}
                <div className={css.setLoc} onClick={getCurrentLoc}>
                  <MdMyLocation />
                </div>
                {selected ? (
                  <InfoWindow
                    position={{ lat: selected.lat, lng: selected.lng }}
                    onCloseClick={() => {
                      setSelected(null);
                    }}
                  ></InfoWindow>
                ) : null}
              </GoogleMap>
            </div>
            <div className={css.addressForm}>
              <div className={css.loc}>
                <div className={css.locIcon}>
                  <Location />
                </div>
                <div className={css.selectedLoc}>
                  <h4>
                    <FormattedMessage
                      id="addaddress_selectlocation"
                      defaultMessage=" Select Location"
                    />
                  </h4>
                  <input
                    className={css.locationInput}
                    value={markers[0] ? markers[0].address : ''}
                    disabled
                    type="text"
                    placeholder="Address Location"
                  />
                  {validateError && <div className={css.warning}>{validateError}</div>}
                </div>
              </div>

              <Button
                className={css.button}
                variant="contained"
                color="primary"
                onClick={() => {
                  setAddInfo(true);
                  dispatch(setCloseEditAddressPopup(true));
                }}
                disabled={markers.length === 0 || validateError}
              >
                <FormattedMessage
                  id="addaddress_confirmlocation"
                  defaultMessage="Confirm Location"
                />
              </Button>
            </div>
            {!isDesktop && addInfo && !countryPopup && (
              <DrawerPwa
                variant="temporary"
                anchor="bottom"
                onClose={changeMap}
                className={css.nobg}
                // anchor="bottom"
                open={addInfo}
              >
                <ChangeAddress
                  markers={markers}
                  changeMap={changeMap}
                  setBldNu={setBldNu}
                  bldNu={bldNu}
                  buildingPlaceholder={buildingPlaceholder}
                  setFlatNu={setFlatNu}
                  flatNu={flatNu}
                  flatNoPlaceholder={flatNoPlaceholder}
                  setHowTo={setHowTo}
                  howTo={howTo}
                  howToReachpl={howToReachpl}
                  allTags={allTags}
                  setTag={setTag}
                  tag={tag}
                  handleForm={handleForm}
                  status={status}
                  buttonText={'editaddress_editaddress'}
                />
              </DrawerPwa>
            )}
            {isDesktop && addInfo && (
              <div className={ClassNames(css.openDrawerInfo, { [css.activeDrawer]: addInfo })}>
                <div className={css.closeButton} onClick={changeMap}>
                  <GrClose size=".8em" />
                </div>

                <ChangeAddress
                  markers={markers}
                  changeMap={changeMap}
                  setBldNu={setBldNu}
                  bldNu={bldNu}
                  buildingPlaceholder={buildingPlaceholder}
                  setFlatNu={setFlatNu}
                  flatNu={flatNu}
                  flatNoPlaceholder={flatNoPlaceholder}
                  setHowTo={setHowTo}
                  howTo={howTo}
                  howToReachpl={howToReachpl}
                  allTags={allTags}
                  setTag={setTag}
                  tag={tag}
                  handleForm={handleForm}
                  status={status}
                  buttonText={'editaddress_editaddress'}
                />
              </div>
            )}
          </div>
        </div>
        <DrawerPwa
          variant="temporary"
          className={css.nobg}
          anchor="bottom"
          onClose={handleClickAway}
          open={stateOpen}
        >
          <div className={css.errorDrawer}>
            <div className={css.topPos}>
              <div className={css.strip}></div>
              <div className={css.strip}></div>
              <div className={css.strip}></div>
            </div>
            <div className={css.error}>{errorResponse ? errorResponse : null}</div>
            <Button className={css.ErrorB} onClick={handleClickAway}>
              <FormattedMessage id="editaddress_close" defaultMessage="Close" />
            </Button>
          </div>
        </DrawerPwa>
      </main>
      <footer className={css.footer}></footer>
    </div>
  );
}

export default EditAddress;
